// Loading-screen hype lines, placed by context.
//  • WELCOME  → login + /home (you're arriving / already in)
//  • SALES    → sales dashboards only (Sales CRM, LMS)
//  • GENERAL  → everywhere else (cheesy / dev / punchy)
// One is picked at random per load; the emoji glyph also alternates.

const LOADING_EMOJIS = ["🤘🏽", "💯"];

const WELCOME = [
  // greetings
  "Sup — grabbing your stuff… 🤙",
  "Hey hey — one sec ✋",
  "Hello, legend. Loading you in 🫡",
  "Yo! Rolling out the red carpet 🎬",
  "Welcome back — dusting off your desk 🧹",
  "Namaste 🙏 loading your day",
  "Oh, it's you. Loading the good stuff 😎",
  "Hey superstar, almost ready 🌟",
  "Knock knock… it's your dashboard 🚪",
  "Good to see you. Two seconds 👀",
  "Well well well, look who logged in 😏",
  "Ayy, you made it. Hang tight 🙌",
  "Hola! Warming things up 🔥",
  "Morning, champ (or evening — whatever) ☀️",
  "What's good? Loading what's good ✨",
  // wholesome
  "You showed up. Respect 🫡",
  "Proud of you for logging in today 🥹",
  "Take a breath — you've earned it 🌿",
  "Good things take a sec 🌸",
  "Stay awesome — one moment 💫",
  "You matter here. Loading your space 💛",
  "Hydrate while you wait 💧",
  "Sit back — we've got this 🛋️",
  "Thanks for being here today 🙏",
  "Little wins add up. Loading yours 🧩",
  "Almost ready — go easy on yourself 🌼",
  "Fresh start, loading now 🌅",
  "You + this team = unstoppable 🤝",
  "Rooting for you. Always 📣",
  // hype
  "Big things loading 🚀",
  "Let's get after it 💪",
  "Hustle mode: on 🔛",
  "Today's the day. Loading it 📅",
  "Go time in 3… 2… 🏁",
  "Making moves. Give it a sec ♟️",
  "Loading your main-character energy 🎬",
  "Winners load in silence 🤫",
  "Locked in. Loading 🔒",
  "Greatness is buffering ⏳",
  "Deep breath — here we go 🌬️",
  "You've got this. We've got the rest 🫶",
  "Momentum loading… 🌊",
  "Another day to be unstoppable ⚡",
  "Let's make it count 🎯",
];

const SALES = [
  "ABC — Always Be Closing. Also, loading 🤝",
  "Pipeline's loading. So is the money 💸",
  "Chasing the bag — loading it first 💰",
  "Every lead counts. Loading yours 📈",
  "Closing tabs, opening deals 🤝",
  "Loading your next big win 🏆",
  "Coffee's for closers. Load's for everyone ☕",
  "Numbers up, load in 📊",
  "Your funnel, loading 🕳️",
  "Sealing the deal (and the dashboard) ✍️",
  "From lead to legend — loading 🌟",
  "Quota won't hit itself. Loading 🎯",
  "Follow up, close, repeat. Loading 🔁",
];

const GENERAL = [
  // cheesy
  "Loading the good vibes ✨",
  "Sprinkling a little magic… 🪄",
  "Warming up the good vibes 🔥",
  "Fetching sunshine and pixels 🌞",
  "Assembling awesomeness… 🧩",
  "Adding a pinch of sparkle ✨",
  "Loading… now with 100% more you 💯",
  "Brewing something nice ☕",
  "Untangling the internet cables… 🔌",
  "Bribing the servers with chai 🍵",
  "Feeding the hamsters that run this thing 🐹",
  "Polishing the pixels… ✨",
  "Rounding up all the good bytes 🤠",
  "Loading like it owes you money 🏃",
  "Almost there — pinky promise 🤞",
  // dev
  "Compiling brilliance… 🧠",
  "Turning coffee into code ☕",
  "git pull origin greatness 🌿",
  "Deploying good vibes to prod 🚢",
  "99 problems but this load ain't one 🎧",
  "Reticulating splines… 🧵",
  "It works on my machine — loading yours 💻",
  "Summoning the data goblins 👺",
  "sudo make me a dashboard 🧑‍💻",
  "Waking up the backend (it's shy) 😴",
  "Loading… blame the WiFi if it's slow 📶",
  "Optimizing the flux capacitor ⚡",
  "Fetching bytes, one vibe at a time 🔢",
  "Spinning up the good stuff 🌀",
  "Caching your greatness 🗃️",
  // punchy
  "Almost there 🏁",
  "Hang tight 🤙",
  "Two seconds ✌️",
  "Nearly ready 👌",
  "Loading legendary 🐐",
  "Patience, champion 🧘",
  "Cooking… 🍳",
  "On it ⚡",
  "Buckle up 🎢",
  "Here we go 🚀",
  "Loading greatness 🌟",
  "Worth the wait 💎",
];

const SALES_PREFIXES = ["/lms", "/crm"];

function rand(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

// Pick a line appropriate to where the user is loading.
export function pickLoadingLine(path = "") {
  const p = (path || "").toLowerCase();
  if (SALES_PREFIXES.some((s) => p.startsWith(s))) return rand([...SALES, ...GENERAL]);
  if (p === "" || p === "/" || p.startsWith("/home") || p.startsWith("/login")) return rand(WELCOME);
  // elsewhere: a little welcome warmth + general fun
  return rand([...WELCOME.slice(0, 8), ...GENERAL]);
}

export function pickLoadingEmoji() {
  return rand(LOADING_EMOJIS);
}
